import { render, staticRenderFns } from "./ReplyMessagePreview.vue?vue&type=template&id=72c2f4ac"
import script from "./ReplyMessagePreview.vue?vue&type=script&lang=js"
export * from "./ReplyMessagePreview.vue?vue&type=script&lang=js"
import style0 from "./ReplyMessagePreview.vue?vue&type=style&index=0&id=72c2f4ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports